import { Grid, Tabs as MuiTabs, Tab as MuiTab, TabsProps as MuiTabsProps } from '@mui/material';
import React from 'react';

export interface TabItem {
  id: string;
  label: string;
  content: React.ReactNode;
  visible?: boolean;
}

export type TabNavigationProps = MuiTabsProps & {
  tabs: TabItem[];
};

export const TabNavigation: React.FC<TabNavigationProps> = ({
  tabs,
  className = 'bordered',
  ...rest
}) => {
  if (!tabs.length) return null;

  return (
    <MuiTabs className={className} {...rest}>
      {tabs.map(tab => (
        <MuiTab
          key={tab.id}
          label={tab.label}
          className={className}
          sx={{ display: tab.visible === false ? 'none' : undefined }}
        />
      ))}
    </MuiTabs>
  );
};

interface TabContentProps {
  value: number;
  tabs: TabItem[];
}

export const TabContent: React.FC<TabContentProps> = ({ value, tabs, ...rest }) => {
  const tab = tabs[value];

  if (!tab || tab.visible === false) return null;

  return (
    <Grid paddingTop={3} {...rest}>
      {tab.content}
    </Grid>
  );
};
